const anchorScroll = (element) => {
  var _a, _b, _c, _d;
  const stickyHeaderHeight = ((_a = document.querySelector('[id="SITE_HEADER"]')) == null ? void 0 : _a.clientHeight) || 0;
  const stickyAd = ((_b = document.querySelector('[id="WIX_ADS"]')) == null ? void 0 : _b.clientHeight) || 0;
  const mobileToolbar = ((_c = document.querySelector('[data-hook="mobileToolbar"]')) == null ? void 0 : _c.clientHeight) || ((_d = document.querySelector('[data-hook="ricos-editor-toolbars"]')) == null ? void 0 : _d.clientHeight) || 0;
  const fixedElementsOffset = stickyHeaderHeight + stickyAd + mobileToolbar;
  anchorScrollUsingScrollIntoView(element, fixedElementsOffset);
};
const anchorScrollUsingScrollIntoView = (element, fixedElementsOffset) => {
  const { paddingTop, marginTop } = element.style;
  element.style.marginTop = `-${fixedElementsOffset}px`;
  element.style.paddingTop = `${fixedElementsOffset}px`;
  element.scrollIntoView({ behavior: "smooth" });
  element.style.marginTop = marginTop;
  element.style.paddingTop = paddingTop;
};
const addAnchorTagToUrl = (anchorString) => {
  const url = new URL(window.location.href);
  url.hash = anchorString;
  history.pushState({}, "", url.href);
};
const isNewTab = (target) => target === "_blank";
export {
  addAnchorTagToUrl,
  anchorScroll,
  isNewTab
};
//# sourceMappingURL=anchor.js.map
